interface IEnv {
  clientID: string;
  recallsBaseUrl: string;
  authBaseUrl: string;
  systemBaseUrl: string;
  readBaseUrl: string;
}

interface IEnvironments {
  dev: IEnv;
  local: IEnv;
  prod: IEnv;
}

const ENVIRONMENTS: IEnvironments = {
  dev: {
    clientID: "700664373667-94su281c03e18urstpsm4vegid2lubct.apps.googleusercontent.com",
    recallsBaseUrl: "https://distrimate.dev/api/import/v1",
    authBaseUrl: "https://distrimate.dev/api/auth/v1",
    systemBaseUrl: "https://distrimate.dev/api/system/v1",
    readBaseUrl: "https://distrimate.dev/api/read/v1"
  },
  local: {
    clientID: "700664373667-94su281c03e18urstpsm4vegid2lubct.apps.googleusercontent.com",
    recallsBaseUrl: "https://distrimate.dev/api/import/v1",
    authBaseUrl: "https://distrimate.dev/api/auth/v1",
    systemBaseUrl: "https://distrimate.dev/api/system/v1",
    readBaseUrl: "https://distrimate.dev/api/read/v1"
  },
  prod: {
    clientID: "674901036874-hrv3lhqlkp3b0uh8lhoaj0hlmrqd37it.apps.googleusercontent.com",
    recallsBaseUrl: "https://distrimate.com/api/import/v1",
    authBaseUrl: "https://distrimate.com/api/auth/v1",
    systemBaseUrl: "https://distrimate.com/api/system/v1",
    readBaseUrl: "https://distrimate.com/api/read/v1"
  }
};

const ENV: IEnv = typeof process.env.REACT_APP_ENV !== "undefined" ? ENVIRONMENTS[process.env.REACT_APP_ENV] : ENVIRONMENTS.local;

export default ENV;
